export default async function logFetchError(res)
{
    let errorMsg = "";

    const data = await res.text();
    errorMsg = data.message || JSON.parse(data);

    console.error(`Fetch failed (${res.status}):`, errorMsg);
    alert(`Fetch failed: ${errorMsg}`);
}